import {
  getCleanDrawerParams,
  queryKeys,
  queryValues,
} from '@terminal/routes/query-params';

export const getEarningsInsightParentDrawerParams = (
  params: Record<string, string | null>
) => {
  const parentThemeId = params[queryKeys.themeId] ?? undefined;

  if (
    params[queryKeys.activeDrawer] !== queryValues.earningsInsightDrawer ||
    params[queryKeys.parentDrawer] !== queryValues.themeEarningsDrawer ||
    !parentThemeId
  ) {
    return undefined;
  }

  return {
    ...getCleanDrawerParams(),
    [queryKeys.drawerExpanded]: undefined,
    [queryKeys.activeDrawer]: queryValues.themeEarningsDrawer,
    [queryKeys.themeId]: parentThemeId,
  };
};
